/* ============================================================================
   Sixth Man - publish the header bar's real height as --sm-header-h.

   The menu drawer's close button has to sit exactly where the cart icon sits,
   so the drawer's head must be exactly as tall as the header bar. That height
   is not a constant: it is driven by the logo image, which is sized by a theme
   setting (`logo_max_width`) and differs between breakpoints - measured 86px
   on mobile against the 66px the theme's own --sticky-header-height claims.

   Hardcoding it put the X ~10px above the cart. Measured instead, and
   re-measured whenever the bar changes size.
   ============================================================================ */
(function () {
  "use strict";

  var bar = document.querySelector("header .lg\\:relative.section-x-padding")
         || document.querySelector("header .section-x-padding");
  if (!bar) return;

  function publish() {
    var h = Math.round(bar.getBoundingClientRect().height);
    if (h > 0) document.documentElement.style.setProperty("--sm-header-h", h + "px");
  }

  publish();
  window.addEventListener("load", publish);
  window.addEventListener("pageshow", publish);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(publish);

  if ("ResizeObserver" in window) {
    new ResizeObserver(publish).observe(bar);
  } else {
    var t;
    window.addEventListener("resize", function () {
      clearTimeout(t); t = setTimeout(publish, 120);
    });
  }
})();
